import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { Header } from '@/components/header'
import { NavigationModal } from '@/components/NavigationModal'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated()) {
      throw redirect({
        search: {
          redirect: location.href,
        },
        to: '/auth/login',
      })
    }
  },
  component: Authenticated,
})

function Authenticated() {
  return (
    <>
      <Header />
      <NavigationModal />

      <div className="h-full pt-16">
        <Outlet />
      </div>
    </>
  )
}
